import React from "react";
import { useTranslation } from "react-i18next";
import * as ROUTES from "../../constants/routes";
import {
  PROGRAMS_SELECT,
  PROGRAMS_DELETE,
  PROGRAMS_ADD,
  PROGRAMS_UPDATE,
} from "../../constants/roles";
import BreadcrumbLink from "./BreadcrumbLink";

const PROGRAM_PERMISSIONS = [
  PROGRAMS_SELECT,
  PROGRAMS_DELETE,
  PROGRAMS_ADD,
  PROGRAMS_UPDATE,
];

const ProgramLink = () => {
  const { t } = useTranslation();

  return (
    <BreadcrumbLink
      to={ROUTES.PROGRAMS}
      label={t("navigation.programs")}
      permissions={PROGRAM_PERMISSIONS}
    />
  );
};

export default ProgramLink;